import React, { useContext, useMemo } from 'react';
import { UBILogger } from '@spotify-internal/ubi-logger-js/cjs/src';

import { createUbiLogger } from './index';

interface UbiContextType {
  ubiLogger: UBILogger;
}

interface UbiContextProps {
  isLoggedIn: boolean;
  children: React.ReactNode;
}

export const UbiContext = React.createContext<UbiContextType>({
  ubiLogger: createUbiLogger(true),
});

export const useUbiContext = () => {
  return useContext(UbiContext).ubiLogger;
};

const UbiLoggerProvider = ({ isLoggedIn, children }: UbiContextProps) => {
  const ubiLogger = useMemo(() => createUbiLogger(isLoggedIn), [isLoggedIn]);
  const valueProp: UbiContextType = {
    ubiLogger,
  };
  return <UbiContext.Provider value={valueProp}>{children}</UbiContext.Provider>;
};

export default UbiLoggerProvider;
